module.exports = "<p>Site is up.</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/healthcheck/healthcheck.component.html
// module id = ./src/app/components/healthcheck/healthcheck.component.html
// module chunks = main